const PAYOUT_PARAM = 'payouts'
const payoutReturnValues = ['return', 'refresh'] as const

export type PayoutReturn = (typeof payoutReturnValues)[number]

export function parsePayoutReturn(value: unknown): PayoutReturn | undefined {
  return payoutReturnValues.find((known) => known === value)
}

export function payoutReturnUrls(href: string): { returnUrl: string; refreshUrl: string } {
  const at = (value: PayoutReturn) => {
    const url = new URL(href)
    url.hash = ''
    url.search = ''
    url.searchParams.set(PAYOUT_PARAM, value)
    return url.toString()
  }
  return { returnUrl: at('return'), refreshUrl: at('refresh') }
}
